export default "__VITE_PUBLIC_ASSET__a7f1b19b__"